import { IKeyValuePair } from '@/types';

/**
 * 将str里{xxx}的占位符，替换为实际的值；如果obj里没有，那么替换为空字符串
 * @param str
 * @param obj
 * @returns
 */
export function parseStrWitchObj(str: string, obj: IKeyValuePair<string>): string {
  return str.replace(/\{([^}]+)\}/g, (...arg) => {
    try {
      return decodeURIComponent(obj[arg[1]] || '');
    } catch (err) {
      return obj[arg[1]] || '';
    }
  });
}
